import React from "react";

const Button = ({ textButton, onClick, type, style, disabled }) => {
  return (
    <button
      disabled={disabled}
      onClick={onClick}
      className={disabled ? "button-disabled" : "button-basic"}
      type={type}
      style={style}>
      {textButton}
    </button>
  );
};

export default Button;
